import { https } from 'mk-biz-pc'
import { Config } from './config'

const coreApi = https.coreApi

/**
 * 获取导航列表
 * @returns
 */
export const getNavList = () => coreApi(Config.getNavList)

/**
 * 获取导航详情
 * @param id
 * @returns
 */
export const getNav = (id: string) => coreApi(Config.getNav, { params: { id } })

/**
 * 查询导航列表
 * @param params
 * @returns
 */
export const queryNavList = (params: any) => coreApi(Config.queryNavList, { params })

/**
 * 删除导航
 * @param id
 * @returns
 */
export const deleteNav = (id: string) => coreApi(Config.deleteNav, { params: { id } })

/**
 * 添加导航
 * @param data
 * @returns
 */
export const addNav = (data: any) => coreApi(Config.addNav, { data })

/**
 * 更新导航
 * @param data
 * @returns
 */
export const updateNav = (data: any) => coreApi(Config.updateNav, { data })

/**
 * 获取导航及权限点
 * @param appId
 * @returns
 */
export const queryNavPermission = () => coreApi(Config.queryNavPermission, { params: {} })
